export default "__VITE_ASSET__DrcgRjGB__"